const isScrolledIntoView = (elem) => {
  const windowTop = window.scrollY;
  const windowBottom = windowTop + window.innerHeight;
  const elemTop = elem.getBoundingClientRect().top + windowTop;
  const elemBottom = elemTop + elem.offsetHeight;

  return elemTop <= windowBottom && elemBottom >= windowTop;
};

const carouselCheck = (elem) => {
  const closestHeroCarousel = elem.closest('[data-hero-carousel]');
  if (!closestHeroCarousel) {
    // Not in a carousel, all good
    return true;
  }

  const closestSelected = elem.closest('.is-selected');
  if (closestSelected) {
    // This is a carousel, and the video is in the active carousel slide, all good
    return true;
  }

  return false;
};

export default function (elem) {
  return elem.offsetParent !== null && isScrolledIntoView(elem) && carouselCheck(elem);
}
